export default "/images/50ed770c7a6223ffb9d279549da0b0c9.jpg";